<template>
  <div class="page">
    <header-el></header-el>

    <section class="page-hero">
      <div class="ui-container">
        <p class="crumb">首页 / 解决方案</p>
        <h1>解决方案</h1>
        <p class="lede">
          深度融合 AI 算法与行业场景：智能硬件研发、行业解决方案、云服务平台三大板块协同，
          为制造、物流、农牧、珠宝等领域提供全链路数字化转型方案。
        </p>
      </div>
    </section>

    <!-- 三大业务支柱：悬浮白卡 -->
    <div class="ui-container">
      <div class="float-panel pillars">
        <div class="pillar" v-for="p in solutionPillars" :key="p.name">
          <span class="pillar__thumb">
            <img :src="p.image" :alt="p.name" />
          </span>
          <div>
            <h3>{{ p.name }}</h3>
            <p>{{ p.desc }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 方案矩阵 -->
    <section class="section">
      <div class="ui-container">
        <div class="section-head">
          <span class="kicker">SOLUTIONS</span>
          <h2>方案矩阵</h2>
          <p class="sub">物联网 · 智能硬件 · AI 软件 · AR 可视化 · ITO 服务</p>
        </div>

        <div class="group card" v-for="g in solutionGroups" :key="g.name">
          <div class="group__hd">
            <h3>{{ g.name }}</h3>
            <span class="group__slogan">{{ g.slogan }}</span>
          </div>
          <div class="group__body" :class="{ 'group__body--wide': g.items.length > 2 }">
            <div class="group__item" v-for="it in g.items" :key="it.name">
              <h4>{{ it.name }}</h4>
              <p>{{ it.desc }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 典型案例 -->
    <section class="section section--gray">
      <div class="ui-container">
        <div class="section-head">
          <span class="kicker">CASES</span>
          <h2>典型落地案例</h2>
          <p class="sub">深耕行业，创造价值</p>
        </div>
        <div class="case-grid">
          <div class="case card" v-for="c in cases" :key="c.name">
            <div class="case__pic">
              <img :src="c.image" :alt="c.name" />
              <span class="tag tag--solid case__tag">{{ c.tag }}</span>
            </div>
            <div class="case__body">
              <h3>{{ c.name }}</h3>
              <p>{{ c.desc }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <footer-el></footer-el>
  </div>
</template>

<script>
  import Header from "../components/header.vue";
  import Footer from "../components/footer.vue";
  import { solutionPillars, solutionGroups, cases } from "../data/site.js";

  export default {
    components: {
      "header-el": Header,
      "footer-el": Footer
    },
    data() {
      return {
        solutionPillars,
        solutionGroups,
        cases
      };
    }
  };
</script>

<style scoped>
  .pillars {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 26px;
    padding: 30px 32px;
  }
  .pillar { display: flex; gap: 16px; align-items: center; }
  .pillar__thumb {
    flex: none;
    width: 84px;
    height: 84px;
    border-radius: 14px;
    overflow: hidden;
    background: #fdeceb;
    border: 1px solid #f6e0dd;
  }
  .pillar__thumb img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
  .pillar h3 { font-size: 17px; }
  .pillar p { margin-top: 6px; font-size: 13px; color: #4c515b; line-height: 1.7; }

  .group { padding: 28px 32px; margin-bottom: 20px; }
  .group:hover { transform: none; }
  .group__hd {
    display: flex;
    align-items: baseline;
    gap: 14px;
    padding-bottom: 16px;
    border-bottom: 1px solid #f2f3f5;
  }
  .group__hd h3 { font-size: 19px; }
  .group__slogan { font-size: 13px; color: #e8382f; font-weight: 600; }

  .group__body {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 8px 32px;
    margin-top: 18px;
  }
  .group__body--wide { grid-template-columns: repeat(3, 1fr); }
  .group__item { padding: 12px 0; }
  .group__item h4 {
    font-size: 15px;
    display: flex;
    align-items: center;
  }
  .group__item h4::before {
    content: "";
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #e8382f;
    margin-right: 9px;
    flex: none;
  }
  .group__item p {
    margin-top: 6px;
    font-size: 13px;
    color: #8a909b;
    line-height: 1.75;
  }

  .case-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
  }
  .case { padding: 0; overflow: hidden; }
  .case__pic {
    position: relative;
    height: 150px;
    overflow: hidden;
  }
  .case__pic img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    transition: transform 0.35s ease;
  }
  .case:hover .case__pic img { transform: scale(1.05); }
  .case__tag {
    position: absolute;
    left: 12px;
    top: 12px;
  }
  .case__body { padding: 18px 20px 22px; }
  .case__body h3 { font-size: 16px; }
  .case__body p {
    margin-top: 8px;
    font-size: 13px;
    color: #4c515b;
    line-height: 1.8;
  }

  /* ---------- 响应式 ---------- */
  @media (max-width: 1023px) {
    .pillars { grid-template-columns: repeat(2, 1fr); padding: 24px 22px; }
    .group__body--wide { grid-template-columns: repeat(2, 1fr); }
    .case-grid { grid-template-columns: repeat(2, 1fr); }
  }

  @media (max-width: 767px) {
    .pillars { grid-template-columns: 1fr; padding: 20px 16px; gap: 18px; }
    .pillar { gap: 12px; }
    .pillar__thumb { width: 64px; height: 64px; }
    .group { padding: 22px 18px; }
    .group__hd { flex-direction: column; gap: 6px; }
    .group__body { grid-template-columns: 1fr; gap: 0; }
    .group__body--wide { grid-template-columns: 1fr; }
    .case-grid { grid-template-columns: 1fr; }
    .case__pic { height: 140px; }
  }
</style>
